import React, {useEffect, useState} from "react";

// import redux
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../features/store";
import {
  alertsConfirmAction,
  checkListCloseAction,
  checkListSwitchAction,
} from "../../features/sliceReducer/interactionReducer";
import {
  deleteFieldCheck,
  getCheckList,
  getFieldCheck,
  resetFieldCheckAction,
} from "../../features/sliceReducer/myProjectReducer";

//import material-UI
import {makeStyles, createStyles, withStyles, Theme} from "@material-ui/core/styles";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Link,
  IconButton,
} from "@material-ui/core";

import WorkIcon from "@material-ui/icons/Work";
import ListIcon from "@material-ui/icons/List";
import CloseIcon from "@material-ui/icons/Close";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import {BorderBottom} from "@material-ui/icons";

//material-UI-Style
const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: "relative",
      width: "1480px",
      height: "860px",
      paddingBottom: "20px",
      backgroundColor: theme.palette.background.paper,
      border: `2px solid #4f5470`,
      boxShadow: theme.shadows[5],
    },

    table: {
      // marginTop: "72px",
      border: "1px solid #dbdce0",
      "& td": {
        borderBottom: "none",
      },
    },
    buttonCell: {
      display: "flex",
      justifyContent: "space-around",
    },
    modalTitle: {
      position: "fixed",
      width: "1480px",
      padding: "12px 16px",
      textAlign: "center",
      fontSize: "20px",
      fontWeight: "bold",
      backgroundColor: "#4f5470",
      color: "white",
      "& h5": {
        display: "flex",
        alignItems: "center",
        "& svg": {
          paddingRight: "8px",
        },
      },
      "& span": {
        fontSize: "18px",
        fontWeight: "normal",
      },
    },
    searchInput: {
      display: "flex",
      justifyContent: "center",
      marginBottom: " 20px",
    },

    buttonStyle: {
      display: "flex",
      justifyContent: "center",

      "& button": {
        width: "200px",
        height: "40px",
        marginTop: "80px",
      },
    },
    addBtn: {
      color: theme.palette.primary.dark,
    },
  })
);

const FieldCheckList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {userToken} = useSelector((state: RootState) => state.auth);

  const {fieldCheckList, myProject, selectItem, itemName, checkListTableHeader, loading} =
    useSelector((state: RootState) => state.myProject);

  useEffect(() => {
    dispatch(
      getCheckList({
        userToken,
        pid: myProject.uid,
        id: selectItem,
      })
    );
    // console.log(selectItem);
  }, []);

  // note SmokingScully 추가
  const updateCallback = () => {
    dispatch(
      getCheckList({
        userToken,
        pid: myProject.uid,
        id: selectItem,
      })
    );
  };

  return (
    <TableContainer component={Paper} className={classes.paper}>
      <Box
        className={classes.modalTitle}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h5" component="h5">
          <ListIcon />
          첨부 목록 - <span> {itemName}</span>
        </Typography>
        <IconButton onClick={() => dispatch(checkListCloseAction())} aria-label="close">
          <CloseIcon style={{color: "white", fontWeight: "bold"}} />
        </IconButton>
      </Box>
      <Box p="16px" mt="72px">
        <Box display="flex" justifyContent="flex-start" mb="16px">
          <Button
            className={classes.addBtn}
            variant="outlined"
            size="large"
            onClick={() => {
              dispatch(checkListSwitchAction(3));
              dispatch(resetFieldCheckAction());
            }}
            endIcon={<AddToPhotosIcon>send</AddToPhotosIcon>}
          >
            추가
          </Button>
        </Box>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {checkListTableHeader.map((headerTitle, index) => (
                <TableCell key={index} align="center">
                  {headerTitle}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {fieldCheckList?.map((fieldCheck, index) => (
              <StyledTableRow key={fieldCheck.uid}>
                <TableCell align="center">{fieldCheck.uid}</TableCell>
                <TableCell align="center">{fieldCheck.processName}</TableCell>
                <TableCell
                  onClick={() => {
                    dispatch(getFieldCheck({userToken, id: fieldCheck.uid}));
                    dispatch(checkListSwitchAction(1));
                  }}
                  align="center"
                >
                  <Link>{fieldCheck.itemName}</Link>
                </TableCell>
                <TableCell align="center">{fieldCheck.specName}</TableCell>
                <TableCell align="center">{fieldCheck.photoFile1}</TableCell>
                <TableCell align="center">{fieldCheck.photoFile2}</TableCell>
                <TableCell className={classes.buttonCell}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<WorkIcon />}
                    onClick={() => {
                      dispatch(getFieldCheck({userToken, id: fieldCheck.uid}));
                      dispatch(checkListSwitchAction(2));
                    }}
                  >
                    편집
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<WorkIcon />}
                    onClick={() => {
                      dispatch(
                        alertsConfirmAction({
                          alertContent: "해당 첨부목록을 삭제하시겠습니까?",
                          alertAction: deleteFieldCheck({
                            userToken,
                            id: fieldCheck.uid,
                            successHandler: updateCallback,
                          }),
                        })
                      );
                      // dispatch(deleteFieldCheck({ userToken, id: fieldCheck.uid, successHandler: updateCallback }));
                      // dispatch(checkListSwitchAction(3));
                    }}
                  >
                    삭제
                  </Button>
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </TableContainer>
  );
};

export default FieldCheckList;
